import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useGetBannersQuery } from '../redux/api/bannerApi';
// import { useGetRoomBookingQuery } from '../redux/api/roomBooking.Api';
// import {useGetBookingsQuery} from "../redux/api/roomBookingApi"

const Home = () => {



  const { data, error, isLoading } = useGetBannersQuery();
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [pastEvents, setPastEvents] = useState([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get('/api/events');
        if (response.data.status === 'success') {
          setUpcomingEvents(response.data.data.upcoming);
          setPastEvents(response.data.data.past);
        }
      } catch (err) {
        console.error("Error fetching events:", err);
      }
    };
    fetchEvents();
  }, []);

  if (isLoading) return <p>Loading...</p>;
  if (error) return <p>Error loading banners</p>;

  const banners = data?.data?.[0] || {};
  // const roombooking = roomData?.data || {};

  // {useGetBookingsQuery}  

  // Debug output:
  //  console.log("######")

  //  console.log("ROOM BOOKING DATA:", JSON.stringify(roomData));
  // console.log("ROOM BOOKING ERROR:", roomError);



  return (
    <>
      {/* <Header /> */}
      <div className="th-hero-wrapper hero-2" id="hero">
        <div
          className="swiper th-slider hero-slider-2"
          id="hero-thumb"
          data-slider-options='{"effect":"fade"}'
        >

          <div className="swiper-wrapper">
            {/* 'xxxxxxxxx' */}


            <div className="swiper-slide" >
              <div className="hero-inner">
                <div
                  className="th-hero-bg"
                  style={{ backgroundImage: `url(${banners.banner_image})`, backgroundPosition: 'top', backgroundSize: 'cover' }}

                // style={{ backgroundImage: `url('assets/img/hero/slider1.jpg')`,   backgroundPosition: 'top'}}
                ></div>
                <div className="container">
                  <div className="row align-items-center">
                    <div className="col-xl-6">
                      <div className="hero-style2">
                        <span
                          className="sub-title"
                          data-ani="slideindown"
                          data-ani-delay="0.2s"
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 'xxxxxxxxx' */}
          </div>
        </div>
        <div className="slider-controller d-none">
          <div className="slider-pagination"></div>
          <div className="hero-thumb" data-slider-tab="#hero-thumb">
            <div className="tab-btn active">01</div>
            <div className="tab-btn">02</div>
            <div className="tab-btn">03</div>
          </div>
        </div>
        <div className="scroll-down">
          <a href="#about-sec" className="hero-scroll-wrap"><span></span></a>
        </div>
        <div className="social-links">
          <a href="https://www.instagram.com/">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://www.facebook.com/">
            <i className="fab fa-facebook-f"></i>
          </a>
          <a href="https://www.twitter.com/"><i className="fab fa-twitter"></i></a>
          <a href="https://www.linkedin.com/">
            <i className="fab fa-linkedin-in"></i>
          </a>
        </div>
      </div>
      <div className="about-area overflow-hidden space" id="about-sec">
        <div className="container">
          <div className="row gy-5 justify-content-center">
            <div className="col-12">
              <div className="title-area style3 text-center">
                <span className="sub-title text-anime-style-2 m-auto">ABOUT US</span>
                <h2 className="sec-title text-center text-anime-style-3">
                  Sri Adi Shankaracharya Sharada LakshmiNarasimha Peetam
                </h2>
              </div>
            </div>
            <div className="col-md-8 col-lg-8 mt-0 mb-30 mb-xl-0">
              <div className="img-box1 wow fadeInRight" data-wow-delay=".6s">
                <div className="img1" data-bg-src="/web/assets/img/shape/shape-2.png">
                  <img src="/web/assets/img/normal/about-img.jpg" alt="About" />
                </div>
              </div>
            </div>
            <div className="col-10">
              <div className="pe-xl-4 me-xl-3">
                <p className="mt-n2 mb-35 fs-18 wow fadeInUp" data-wow-delay=".3s">
                  Sri Adi Shankaracharya Sharada Lakshminarasimha Peetam, located
                  in the ancient puranic Divyakshetra of Hariharapura, Chikmagalur
                  District, Karnataka, is a revered Dharmapeetam directly
                  established by Jagadguru Sri Adi Shankaracharya. This ancient
                  Dharmapeetam venerates Sri LakshmiNarasimha Swamy and
                  Sri Sharada Parameswari as its presiding deities.
                </p>

                <p className="mt-n2 mb-35 fs-18 wow fadeInUp" data-wow-delay=".4s">
                  With a history dating back to its establishment by Sri Adi
                  Shankaracharya, the Dharmapeetam proudly maintains an unbroken
                  and distinguished lineage of Jagadgurus.
                </p>

                <p className="mt-n2 mb-35 fs-18 wow fadeInUp" data-wow-delay=".4s">
                  Divyakshetra Hariharapura, a sacred land situated on the banks
                  of the river Tunga, holds profound significance in Vedic
                  literature.
                </p>

                <p className="mt-n2 mb-35 fs-18 wow fadeInUp text-center">
                  To reach "DIVYAKSHETRA HARIHARAPURA,"
                  <Link style={{ color: 'blue' }} to="/howtoreach">Click Here</Link>
                </p>

                <div
                  className="btn-group mt-45 justify-content-center align-items-center wow fadeInUp"
                  data-wow-delay=".6s"
                >
                  <Link to="/about" className="th-btn th-icon">
                    <span
                      className="btn-text"
                      data-back="Read More"
                      data-front="Read More"
                    ></span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* EVENTS SECTION */}
      <section
        className="bg-theme overflow-hidden space"
        data-bg-src="assets/img/bg/event-shape.html"
      >
        <div className="container">
          {/* UPCOMING EVENTS */}
          <div className="title-area style3 text-center">
            <span className="sub-title style text-anime-style-2" style={{ color: '#840000' }}>
              ॐ UPCOMING EVENTS
            </span>
            <h2 className="sec-title text-white text-anime-style-3">Our Programs</h2>
          </div>

          <div className="row gy-4 gx-40">
            {upcomingEvents.slice(0, 3).map((event, index) => (
              <div key={event._id} className="col-12">
                <div className="event-box wow fadeInUp" data-wow-delay=".1s">
                  <div className="box-img global-img">
                    <img
                      src={event.image ? `${event.image}` : "/web/assets/img/event/event1.jpg"}
                      alt={event.title}
                      style={{ width: '100%', height: 'auto', maxHeight: '400px', objectFit: 'cover' }}
                    />
                  </div>
                  <div className="box-wrapper">
                    <div className="box-wrapp">
                      <div className="num">
                        <h2 className="box-number">{String(index + 1).padStart(2, '0')}</h2>
                      </div>
                      <div className="box-content">
                        <h3 className="box-title">
                          <a href="#">{event.title}</a>
                        </h3>
                        <div className="event-meta">
                          <a href="#">
                            <i className="fa-solid fa-calendar-days"></i>
                            {new Date(event.fromDate).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}
                          </a>
                        </div>
                        <p className="box-text text-justify">
                          {event.message}
                        </p>
                      </div>
                    </div>
                    {(event.pdfFile || event.externalLink) && (
                      <div className="ms-auto">
                        <a
                          href={event.pdfFile ? (window.location.hostname === 'localhost' && window.location.port !== '8000' ? `http://localhost:8000${event.pdfFile}` : event.pdfFile) : event.externalLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="th-btn th-icon"
                        >
                          <span className="btn-text">Know More</span>
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {upcomingEvents.length > 0 && (
            <div className="event-box mt-4 wow fadeInUp p-3" data-wow-delay=".1s" style={{ borderRadius: '12px', background: '#f5f5f5' }}>
              <div className="d-flex justify-content-center w-100">
                <Link to="/upcoming-events" className="th-btn th-icon" style={{ backgroundColor: '#ffc107', color: '#000' }}>
                  <span className="btn-text">View All Events</span>
                </Link>
              </div>
            </div>
          )}

          {/* PAST EVENTS */}
          <div className="title-area style3 text-center mt-5">
            <span
              className="sub-title style text-anime-style-2"
              style={{ color: '#840000' }}
            >
              ॐ PAST EVENTS
            </span>
          </div>
          <div className="row gy-4 gx-40">
            {pastEvents.length > 0 ? (
              pastEvents.slice(0, 3).map((event, index) => (
                <div key={event._id} className="col-12">
                  <div className="event-box wow fadeInUp" data-wow-delay=".1s">
                    <div className="box-img global-img">
                      <img
                        src={event.image ? `${event.image}` : "/web/assets/img/event/event1.jpg"}
                        alt={event.title}
                        style={{ width: '100%', height: 'auto', maxHeight: '400px', objectFit: 'cover' }}
                      />
                    </div>
                    <div className="box-wrapper">
                      <div className="box-wrapp">
                        <div className="box-content">
                          <h3 className="box-title">
                            <a href="#">{event.title}</a>
                          </h3>
                          <div className="event-meta">
                            <a href="#">
                              <i className="fa-solid fa-calendar-days"></i>
                              {new Date(event.fromDate).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}
                            </a>
                          </div>
                          <p className="box-text text-justify">
                            {event.message}
                          </p>
                        </div>
                      </div>
                      {(event.pdfFile || event.externalLink) && (
                        <div className="ms-auto">
                          <a
                            href={event.pdfFile ? (window.location.hostname === 'localhost' && window.location.port !== '8000' ? `http://localhost:8000${event.pdfFile}` : event.pdfFile) : event.externalLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="th-btn th-icon"
                          >
                            <span className="btn-text">View More</span>
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center text-white pb-3">No past events found.</div>
            )}
          </div>

          <div className="event-box mt-4 wow fadeInUp p-3" data-wow-delay=".1s" style={{ borderRadius: '12px', background: '#f5f5f5' }}>
            <div className="d-flex justify-content-center w-100">
              <Link to="/events" className="th-btn th-icon" style={{ backgroundColor: '#ffc107', color: '#000' }}>
                <span className="btn-text">View All Events</span>
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* <Footer /> */}
    </>
  );
};

export default Home;
